import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void): () => void {
  document.addEventListener('visibilitychange', onChange);
  return () => document.removeEventListener('visibilitychange', onChange);
}

function getSnapshot(): boolean {
  return document.visibilityState !== 'hidden';
}

function getServerSnapshot(): boolean {
  return true;
}

/**
 * Whether the admin tab is visible. Background polls and the live SSE stream
 * pause while this is false so a forgotten tab sends nothing to Go (Cloud Run
 * can then scale to zero).
 */
export function useDocumentVisible(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
